var path = 'app/scripts/modules/azure/src/serverGroup/configure/wizard/securityGroup/securityGroups.html';
var html = "<div class=\"row\">\n  <azure-server-group-security-groups-selector command=\"command\"></azure-server-group-security-groups-selector>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;